module.exports = __webpack_public_path__ + "img/ico-twitter-circle.26fd6db2.svg";